<tax-page-header titleText="login.title"></tax-page-header>

<div class="ui-kit-white-card">
  <tax-login-menu></tax-login-menu>
  <tax-eds-content (signatureGenerated)="login($event)"></tax-eds-content>
</div>
